// Helper function to normalize vectors
function normalizeVector(v) {
  const len = Math.hypot(v.x, v.y);
  return len === 0 ? { x: 0, y: 0 } : { x: v.x / len, y: v.y / len };
}

// Moves the line while preserving angles and line directions
export default function moveLinePreserveAllAngles(
  movingLine,
  nextLine,
  prevLine,
  xDiff,
  yDiff
) {
  const from = movingLine.from;
  const to = movingLine.to;

  // Vector of the moving line and its perpendicular (normal)
  const lineVec = { x: to.x - from.x, y: to.y - from.y };
  const normal = normalizeVector({ x: -lineVec.y, y: lineVec.x });

  // Project mouse movement onto line's normal direction
  const mouseDot = xDiff * normal.x + yDiff * normal.y;

  // Directions of neighboring lines
  const prevDir = normalizeVector({ x: from.x - prevLine.from.x, y: from.y - prevLine.from.y });
  const nextDir = normalizeVector({ x: nextLine.to.x - to.x, y: nextLine.to.y - to.y });

  // Calculate how much each point should move along its neighboring line to keep angles intact
  const prevProjectionOnNormal = prevDir.x * normal.x + prevDir.y * normal.y;
  const nextProjectionOnNormal = nextDir.x * normal.x + nextDir.y * normal.y;

  // Calculate the exact distance to move along each neighboring line
  const prevMove = mouseDot / prevProjectionOnNormal;
  const nextMove = mouseDot / nextProjectionOnNormal;

  // Save initial positions for attachment adjustments
  const oldFrom = { x: movingLine.from.x, y: movingLine.from.y };
  const oldTo   = { x: movingLine.to.x,   y: movingLine.to.y };

  // Move 'from' point along previous line direction
  from.x += prevDir.x * prevMove;
  from.y += prevDir.y * prevMove;

  // Move 'to' point along next line direction
  to.x += nextDir.x * nextMove;
  to.y += nextDir.y * nextMove;

  // Calculate how much 'from' and 'to' actually moved
  const deltaFrom = {
    x: from.x - oldFrom.x,
    y: from.y - oldFrom.y
  };
  const deltaTo = {
    x: to.x - oldTo.x,
    y: to.y - oldTo.y
  };

  // Attachments adjustment
  const linesToAdjust = [movingLine, prevLine, nextLine];

  linesToAdjust.forEach(adjLine => {
    if (!adjLine) return;

    const dx = (adjLine === prevLine) ? deltaFrom.x : deltaTo.x;
    const dy = (adjLine === prevLine) ? deltaFrom.y : deltaTo.y;

    if (adjLine.isWithBumpout()) {
      adjLine.bumpoutOverlay.moveBumpout(-dx, -dy);
    }

    if (adjLine.isWithMitered()) {
      adjLine.miteredOverlay.moveMitered(-dx, -dy);
    }

    if (adjLine.isWithUnderlayment()) {
      adjLine.underlaymentOverlay.moveMitered(-dx, -dy);
    }
  });
}
